var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv2-flex ppv2-flex-1 ppv2-items-center ppv2-gap-2 ppv2-rounded ppv2-px-3 ppv2-py-1 address-bar"},[_c('Lock'),_vm._v(" "),_c('span',{style:(_vm.textStyles)},[_vm._v("\n        "+_vm._s(_vm.url)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }